export const About = () => (
  <div className="text-sm bg-neutral-100 text-black opacity-70 p-4 rounded-3xl">
    Metadata Portal is a self-hosted web page which shows you the latest
    metadata for a given network.
  </div>
);
